import { useForkRef } from '@cian/react-utils';
import * as React from 'react';
import { debounce } from 'throttle-debounce';
import { useSliderContext } from '../../utils/sliderContext';
import { useCallbackRef } from '../../utils/useCallbackRef';
import * as styles from './Scroller.css';
import { Slide } from './components/Slide';
import { jsx as _jsx } from "react/jsx-runtime";
export var Scroller = function Scroller(_ref) {
  var _initChildrenArray$cu;

  var children = _ref.children,
      onScrollEnd = _ref.onScrollEnd;
  var localScrollerRef = React.useRef(null);

  var _useSliderContext = useSliderContext(),
      contextScrollerRef = _useSliderContext.scrollerRef;

  var scrollerRef = useForkRef(localScrollerRef, contextScrollerRef);
  var handleScrollEnd = React.useCallback(debounce(100, function () {
    if (onScrollEnd) {
      onScrollEnd();
    }
  }), [onScrollEnd]);
  React.useEffect(function () {
    var scrollerRef = localScrollerRef.current;

    if (!scrollerRef) {
      return;
    }

    scrollerRef.addEventListener('scroll', handleScrollEnd, {
      passive: true
    });
    return function () {
      return scrollerRef.removeEventListener('scroll', handleScrollEnd);
    };
  }, [handleScrollEnd]);
  var childrenArray = React.Children.toArray(children);
  var initChildrenArray = useCallbackRef(function () {
    return childrenArray.slice(0, 3);
  });
  React.useEffect(function () {
    initChildrenArray.current = null;
  });
  return /*#__PURE__*/_jsx("ul", {
    ref: scrollerRef,
    className: styles['container'],
    children: ((_initChildrenArray$cu = initChildrenArray.current) !== null && _initChildrenArray$cu !== void 0 ? _initChildrenArray$cu : childrenArray).map(function (child, index) {
      return /*#__PURE__*/_jsx(Slide, {
        index: index,
        children: child
      }, "slide_".concat(index));
    })
  });
};